
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.004 4.697c.447-2.52-2.73-4.004-4.376-2.045l-7.039 8.383c-1.366 1.627-.21 4.108 1.915 4.108h3.635a.5.5 0 01.492.587l-.635 3.573c-.447 2.52 2.731 4.004 4.377 2.044l7.038-8.382c1.366-1.627.21-4.108-1.915-4.108h-3.635a.5.5 0 01-.492-.587l.635-3.573z"}})])
          )
        }
      }
    